module.exports = __webpack_public_path__ + "static/media/placeholder-3.84b34917.jpg";